import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {getSuppliers} from "../Supplier/actions";
import {Button, Card, Form, Input, notification, Select} from 'antd';

import {addBulkProduct} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout} from "../utils/style";
import {bindActionCreators} from "redux";

const FormItem = Form.Item;
const TextArea = Input.TextArea;
const ButtonGroup = Button.Group;
const Option = Select.Option;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class AddBulkProductForm extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    /* actions */
    addBulkProduct: PropTypes.func.isRequired,
    getSuppliers: PropTypes.func.isRequired,
    /* state */
    loading: PropTypes.bool.isRequired,
    form: PropTypes.object.isRequired,
    dispensaryId: PropTypes.string.isRequired,
    suppliers: PropTypes.array.isRequired,
  };
  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (this.props.dispensaryId !== prevProps.dispensaryId) this._load();
  }

  _load() {
    const {dispensaryId} = this.props;
    this.props.getSuppliers({dispensaryId});
  }

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {dispensaryId} = this.props;
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.addBulkProduct({...values, dispensaryId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading, suppliers} = this.props;
    return (
      <Card title="Add Bulk Product">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Supplier"
          >
            {getFieldDecorator('supplierId', {
              initialValue: null
            })(
              <Select>
                <Option key="addBulkProduct-supplierId-null" value={null}>NONE</Option>
                {suppliers.map(({supplierId, name}) => <Option key={supplierId} value={supplierId}>{name}</Option>)}
              </Select>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Description"
          >
            {getFieldDecorator('description', {
              initialValue: ''
            })(
              <TextArea />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Unit Of Measure Class"
          >
            {getFieldDecorator('unitOfMeasureClass', {
              rules: [{
                required: true,
                message: 'Unit Of Measure Class is required'
              }]
            })(
              <Select>
                <Option key="each" value="each">Each</Option>
                <Option key="weight" value="weight">Weight</Option>
                <Option key="volume" value="volume">Volume</Option>
              </Select>
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Add Bulk Product
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

const AddBulkProductPage = Form.create()(AddBulkProductForm);

const mapStateToProps = state => ({
  loading: state.bulkProduct.addingBulkProduct || state.supplier.gettingSuppliers,
  dispensaryId: state.dispensary.selectedDispensaryId,
  suppliers: state.supplier.suppliers,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  addBulkProduct,
  getSuppliers,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(AddBulkProductPage);



// WEBPACK FOOTER //
// ./src/BulkProduct/AddBulkProductPage.js